import { action } from 'typesafe-actions';
import { PersonalInfoActionTypes } from './types';

export const createUpdatePIFieldAction = (fieldName: string, value: any, refValue?: any) =>
  action(PersonalInfoActionTypes.UPDATE_PI_FIELD, {
    fieldName,
    value,
    refValue,
  });
